import React from 'react';
import { motion } from 'framer-motion';
export function Comparison() {
  return <section className="comparison" data-id="element-19">
      <motion.div className="container" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-40px'
    }} transition={{
      duration: 0.8
    }} data-id="element-20">
        <span className="section-tag" style={{
        color: 'var(--gold)'
      }} data-id="element-21">
          La Diferencia
        </span>
        <h2 data-id="element-22">Contratar un diseñador vs. aprender a hacerlo tú.</h2>
        <p className="subtitle" data-id="element-23">
          Una vez que aprendes, nunca más dependes de nadie.
        </p>

        <div className="compare-grid" data-id="element-24">
          <div className="compare-col old" data-id="element-25">
            <div className="compare-header" data-id="element-26">Contratar un Diseñador</div>
            <div className="compare-price-tag" data-id="element-27">$2,000 – $5,000+ USD</div>
            <div className="compare-item" data-id="element-28">
              <div className="compare-icon" data-id="element-29">✕</div>
              <span data-id="element-30">Tarda de 6 a 12 semanas en entregarte algo</span>
            </div>
            <div className="compare-item" data-id="element-31">
              <div className="compare-icon" data-id="element-32">✕</div>
              <span data-id="element-33">Cada cambio pequeño te cuesta más dinero</span>
            </div>
            <div className="compare-item" data-id="element-34">
              <div className="compare-icon" data-id="element-35">✕</div>
              <span data-id="element-36">Dependes de su agenda y su disponibilidad</span>
            </div>
            <div className="compare-item" data-id="element-37">
              <div className="compare-icon" data-id="element-38">✕</div>
              <span data-id="element-39">Si quieres otra página, pagas de nuevo</span>
            </div>
            <div className="compare-item" data-id="element-40">
              <div className="compare-icon" data-id="element-41">✕</div>
              <span data-id="element-42">No entiendes cómo funciona tu propia página</span>
            </div>
          </div>

          <div className="compare-col new" data-id="element-43">
            <div className="compare-header" data-id="element-44">
              Aprenderlo Tú con este Workshop
            </div>
            <div className="compare-price-tag" data-id="element-45">$37 USD — una vez</div>
            <div className="compare-item" data-id="element-46">
              <div className="compare-icon" data-id="element-47">✓</div>
              <span data-id="element-48">Tu página lista en una sola tarde</span>
            </div>
            <div className="compare-item" data-id="element-49">
              <div className="compare-icon" data-id="element-50">✓</div>
              <span data-id="element-51">Cambias colores, textos e imágenes cuando quieras</span>
            </div>
            <div className="compare-item" data-id="element-52">
              <div className="compare-icon" data-id="element-53">✓</div>
              <span data-id="element-54">No dependes de nadie — tú tienes el control total</span>
            </div>
            <div className="compare-item" data-id="element-55">
              <div className="compare-icon" data-id="element-56">✓</div>
              <span data-id="element-57">
                Puedes crear páginas ilimitadas con la misma habilidad
              </span>
            </div>
            <div className="compare-item" data-id="element-58">
              <div className="compare-icon" data-id="element-59">✓</div>
              <span data-id="element-60">Entiendes todo porque tú la construiste</span>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}